(function () {
  'use strict';

  var page = document.querySelector('[data-saved-products-page]');
  var saved = window.themeSavedProducts;
  if (!page || !saved) return;

  var rootUrl = page.getAttribute('data-root-url') || '/';
  var pageUrl = page.getAttribute('data-page-url') || '/pages/sparade-produkter';
  var title = page.querySelector('[data-saved-title]');
  var lede = page.querySelector('[data-saved-lede]');
  var count = page.querySelector('[data-saved-count]');
  var tools = page.querySelector('[data-saved-tools]');
  var shareButton = page.querySelector('[data-saved-share]');
  var shareLabel = page.querySelector('[data-saved-share-label]');
  var printButton = page.querySelector('[data-saved-print]');
  var importButton = page.querySelector('[data-saved-import]');
  var bulk = page.querySelector('[data-saved-bulk]');
  var addAllButton = page.querySelector('[data-saved-add-all]');
  var addAllLabel = page.querySelector('[data-saved-add-all-label]');
  var removeTemplate = page.querySelector('[data-saved-remove-template]');
  var cartTemplate = page.querySelector('[data-saved-cart-template]');
  var loading = page.querySelector('[data-saved-loading]');
  var list = page.querySelector('[data-saved-list]');
  var empty = page.querySelector('[data-saved-empty]');
  var error = page.querySelector('[data-saved-error]');
  var printTimestamp = page.querySelector('[data-saved-print-timestamp]');
  var printRows = page.querySelector('[data-saved-print-rows]');
  var printUnique = page.querySelector('[data-saved-print-unique]');
  var printItems = page.querySelector('[data-saved-print-items]');
  var printTotal = page.querySelector('[data-saved-print-total]');
  var sharedEntries = readSharedEntries();
  var sharedMode = sharedEntries.length > 0;
  var renderedEntries = [];
  var renderVersion = 0;

  function joinRoot(path) {
    return rootUrl.replace(/\/+$/, '/') + String(path || '').replace(/^\/+/, '');
  }

  function readSharedEntries() {
    var value = new URL(window.location.href).searchParams.get('lista');
    if (!value) return [];

    var seen = {};
    return value.split(',').map(function (token) {
      var parts = token.split('~');
      var handle = '';
      try {
        handle = decodeURIComponent(parts[0] || '').replace(/[^a-z0-9-]/gi, '');
      } catch (_error) {
        return null;
      }
      var variantId = String(parts[1] || '').replace(/\D/g, '');
      var quantity = Math.min(999, Math.max(1, parseInt(parts[2], 10) || 1));
      if (!handle || !variantId || seen[variantId]) return null;
      seen[variantId] = true;
      return { handle: handle, variantId: variantId, quantity: quantity };
    }).filter(Boolean);
  }

  function imageUrl(value) {
    if (!value) return '';
    var url = typeof value === 'string' ? value : (value.src || value.url || '');
    if (url.indexOf('//') === 0) return 'https:' + url;
    return url;
  }

  function money(cents) {
    return new Intl.NumberFormat('sv-SE', {
      style: 'currency',
      currency: 'SEK',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format((Number(cents) || 0) / 100);
  }

  function fallbackEntry(stored) {
    var handle = String(stored.handle || saved.handleFromUrl(stored.url) || '');
    return {
      variantId: String(stored.variantId),
      quantity: Math.max(1, parseInt(stored.quantity, 10) || 1),
      handle: handle,
      title: stored.title || 'Produkt som inte längre kan hämtas',
      variantTitle: stored.variantTitle || '',
      vendor: stored.vendor || '',
      sku: stored.sku || '',
      url: /^[a-z0-9-]+$/i.test(handle) ? joinRoot('products/' + encodeURIComponent(handle) + '?variant=' + encodeURIComponent(stored.variantId)) : '#',
      price: Number(stored.price) || 0,
      image: imageUrl(stored.image),
      available: false,
      current: false,
      stockLabel: 'Kan inte längre hämtas',
      stockClass: 'product-card__stock--none',
      maxQuantity: null
    };
  }

  function currentEntry(stored, productData) {
    if (!productData || String(productData.variantId) !== String(stored.variantId)) {
      return fallbackEntry(stored);
    }

    var maxQuantity = parseInt(productData.maxQuantity, 10);
    if (!maxQuantity || maxQuantity < 1) maxQuantity = null;
    var quantity = Math.max(1, parseInt(stored.quantity, 10) || 1);
    if (maxQuantity) quantity = Math.min(quantity, maxQuantity);

    var handle = productData.handle || stored.handle;
    return {
      variantId: String(stored.variantId),
      quantity: quantity,
      handle: handle,
      title: productData.title || stored.title || 'Produkt',
      variantTitle: productData.variantTitle || '',
      vendor: productData.vendor || stored.vendor || '',
      sku: productData.sku || stored.sku || '',
      url: joinRoot('products/' + encodeURIComponent(handle) + '?variant=' + encodeURIComponent(stored.variantId)),
      price: Number(productData.price) || Number(stored.price) || 0,
      image: imageUrl(productData.image || stored.image),
      available: Boolean(productData.available),
      current: true,
      stockLabel: productData.stockLabel || (productData.available ? 'Tillgänglig' : 'Tillfälligt slut'),
      stockClass: productData.stockClass || (productData.available ? 'product-card__stock--ok' : 'product-card__stock--none'),
      maxQuantity: maxQuantity
    };
  }

  function fetchEntry(stored) {
    var handle = stored.handle || saved.handleFromUrl(stored.url);
    if (!handle) return Promise.resolve(fallbackEntry(stored));

    var endpoint = joinRoot('products/' + encodeURIComponent(handle)) +
      '?variant=' + encodeURIComponent(stored.variantId) + '&sections=saved-product-data';

    /* Skicka inte Accept: application/json här. Shopify tolkar då produkt-URL:n
       som Admin-lik produkt-JSON och ignorerar `sections`, trots att svaret är
       200. Standard-accepten ger Section Rendering API:s JSON-objekt. */
    return fetch(endpoint).then(function (response) {
      if (!response.ok) throw new Error('product ' + response.status);
      return response.json();
    }).then(function (payload) {
      var markup = payload && payload['saved-product-data'];
      if (!markup) throw new Error('product data missing');
      /* Läs bara vårt JSON-script ur det lilla sektionsfragmentet. Det här är
         mindre och robustare än att bygga ett helt DOM-träd per produkt; vissa
         inbäddade webbläsare exponerar dessutom DOMParser som ett objekt men
         inte som en konstruktor. Shopifys `json`-filter escapear script-slut. */
      var match = markup.match(/<script[^>]*data-saved-product-data[^>]*>([\s\S]*?)<\/script>/i);
      if (!match) throw new Error('product data invalid');
      return currentEntry(stored, JSON.parse(match[1]));
    }).catch(function () {
      return fallbackEntry(stored);
    });
  }

  function textElement(tag, className, value) {
    var element = document.createElement(tag);
    element.className = className;
    element.textContent = value;
    return element;
  }

  function quantityControl(entry) {
    var id = 'SavedQuantity-' + entry.variantId;
    var stepper = document.createElement('div');
    stepper.className = 'qty-stepper saved-products__stepper';
    stepper.setAttribute('data-qty-stepper', '');

    var decrease = textElement('button', 'qty-stepper__btn', '−');
    decrease.type = 'button';
    decrease.setAttribute('data-qty-decrease', '');
    decrease.setAttribute('aria-controls', id);
    decrease.setAttribute('aria-label', 'Minska antal');
    stepper.appendChild(decrease);

    var label = textElement('label', 'visually-hidden', 'Antal');
    label.htmlFor = id;
    stepper.appendChild(label);

    var input = document.createElement('input');
    input.className = 'qty-stepper__input';
    input.type = 'number';
    input.id = id;
    input.value = String(entry.quantity);
    input.min = '1';
    if (entry.maxQuantity) input.max = String(entry.maxQuantity);
    input.inputMode = 'numeric';
    input.setAttribute('data-saved-quantity', entry.variantId);
    stepper.appendChild(input);

    var increase = textElement('button', 'qty-stepper__btn', '+');
    increase.type = 'button';
    increase.setAttribute('data-qty-increase', '');
    increase.setAttribute('aria-controls', id);
    increase.setAttribute('aria-label', 'Öka antal');
    stepper.appendChild(increase);

    return stepper;
  }

  function removeControl(entry) {
    var button = removeTemplate && removeTemplate.content.firstElementChild
      ? removeTemplate.content.firstElementChild.cloneNode(true)
      : textElement('button', 'saved-products__remove', 'Ta bort');
    button.type = 'button';
    button.dataset.savedPageRemove = entry.variantId;
    button.setAttribute('aria-label', 'Ta bort ' + entry.title + ' från sparade produkter');
    return button;
  }

  function setCartButtonState(button, state, entry) {
    var label = button.querySelector('[data-saved-cart-label]');
    var text = 'Lägg ' + entry.title + ' i varukorgen';

    button.classList.toggle('is-loading', state === 'loading');
    button.classList.toggle('is-added', state === 'added');
    button.disabled = state === 'loading' || state === 'added' || state === 'unavailable';

    if (state === 'loading') text = 'Lägger ' + entry.title + ' i varukorgen';
    if (state === 'added') text = entry.title + ' har lagts i varukorgen';
    if (state === 'unavailable') text = entry.title + ' är slut i lager';

    button.title = text;
    if (label) label.textContent = text;
    if (state === 'loading') button.setAttribute('aria-busy', 'true');
    else button.removeAttribute('aria-busy');
  }

  function cartControl(entry) {
    var button = cartTemplate.content.firstElementChild.cloneNode(true);
    button.dataset.savedCart = entry.variantId;
    setCartButtonState(button, entry.available ? 'idle' : 'unavailable', entry);
    return button;
  }

  function printCell(row, className, value) {
    var cell = document.createElement('td');
    cell.className = className;
    if (value !== undefined) cell.textContent = value;
    row.appendChild(cell);
    return cell;
  }

  function updatePrintTimestamp() {
    if (!printTimestamp) return;
    printTimestamp.textContent = new Intl.DateTimeFormat('sv-SE', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    }).format(new Date());
  }

  function renderPrintDocument(entries) {
    if (!printRows || !printUnique || !printItems || !printTotal) return;
    printRows.textContent = '';

    var itemCount = 0;
    var total = 0;

    entries.forEach(function (entry) {
      var row = document.createElement('tr');
      var quantity = Math.max(1, parseInt(entry.quantity, 10) || 1);
      var rowTotal = (Number(entry.price) || 0) * quantity;

      printCell(row, 'saved-products-print__quantity', quantity + ' st');

      var product = printCell(row, 'saved-products-print__product');
      product.appendChild(textElement('strong', 'saved-products-print__product-title', entry.title));
      if (entry.variantTitle) product.appendChild(textElement('span', 'saved-products-print__variant', entry.variantTitle));
      if (entry.vendor) product.appendChild(textElement('span', 'saved-products-print__vendor', entry.vendor));

      printCell(row, 'saved-products-print__sku', entry.sku || '-');
      printCell(row, 'saved-products-print__stock', entry.stockLabel || '-');
      printCell(row, 'saved-products-print__money', entry.price ? money(entry.price) : '-');
      printCell(row, 'saved-products-print__money', entry.price ? money(rowTotal) : '-');
      printRows.appendChild(row);

      itemCount += quantity;
      total += rowTotal;
    });

    printUnique.textContent = String(entries.length);
    printItems.textContent = String(itemCount);
    printTotal.textContent = money(total);
    updatePrintTimestamp();
  }

  function renderRow(entry) {
    var row = document.createElement('article');
    row.className = 'saved-products__row';
    row.setAttribute('role', 'listitem');
    row.setAttribute('data-saved-row', entry.variantId);

    var media = document.createElement('a');
    media.className = 'saved-products__media media media--fit media--square' + (entry.image ? '' : ' media--empty');
    media.href = entry.url;
    media.setAttribute('aria-hidden', 'true');
    media.tabIndex = -1;
    if (entry.image) {
      var image = document.createElement('img');
      image.src = entry.image;
      image.alt = '';
      image.width = 160;
      image.height = 160;
      image.loading = 'lazy';
      image.decoding = 'async';
      media.appendChild(image);
    }
    row.appendChild(media);

    var body = document.createElement('div');
    body.className = 'saved-products__body';
    if (entry.vendor) body.appendChild(textElement('span', 'saved-products__vendor', entry.vendor));

    var productTitle = textElement('a', 'saved-products__product-title', entry.title);
    productTitle.href = entry.url;
    body.appendChild(productTitle);
    if (entry.variantTitle) body.appendChild(textElement('span', 'saved-products__variant', entry.variantTitle));
    if (entry.price) body.appendChild(textElement('strong', 'saved-products__price', money(entry.price)));

    body.appendChild(textElement('span', 'product-card__stock saved-products__stock ' + entry.stockClass, entry.stockLabel));
    body.appendChild(textElement('span', 'saved-products__print-quantity', 'Antal: ' + entry.quantity));
    row.appendChild(body);

    var actions = document.createElement('div');
    actions.className = 'saved-products__actions';
    actions.appendChild(quantityControl(entry));

    actions.appendChild(cartControl(entry));

    if (!sharedMode) actions.appendChild(removeControl(entry));

    row.appendChild(actions);
    return row;
  }

  function setState(entries) {
    renderedEntries = entries;
    list.textContent = '';
    entries.forEach(function (entry) {
      list.appendChild(renderRow(entry));
    });
    renderPrintDocument(entries);

    var availableCount = entries.filter(function (entry) { return entry.available; }).length;
    loading.hidden = true;
    error.hidden = true;
    list.hidden = entries.length === 0;
    empty.hidden = entries.length !== 0;
    tools.hidden = entries.length === 0;
    bulk.hidden = entries.length === 0;
    addAllButton.disabled = availableCount === 0;
    count.textContent = entries.length === 0 ? '' : entries.length + (entries.length === 1 ? ' sparad produkt' : ' sparade produkter');
  }

  function render() {
    var version = ++renderVersion;
    var entries = sharedMode ? sharedEntries : saved.read();

    if (sharedMode) {
      title.textContent = 'Delat prisunderlag';
      lede.textContent = 'Någon har delat de här produkterna och mängderna med dig. Priser och lagerstatus hämtas på nytt när sidan öppnas.';
      importButton.hidden = false;
    }

    if (entries.length === 0) {
      setState([]);
      return Promise.resolve();
    }

    loading.hidden = false;
    list.hidden = true;
    empty.hidden = true;
    error.hidden = true;

    return Promise.all(entries.map(fetchEntry)).then(function (freshEntries) {
      if (version !== renderVersion) return;
      setState(freshEntries);
      saved.publish('saved_list_viewed', { shared: sharedMode, item_count: freshEntries.length });
    }).catch(function () {
      if (version !== renderVersion) return;
      loading.hidden = true;
      error.textContent = 'Listan kunde inte hämtas just nu. Försök igen om en stund.';
      error.hidden = false;
    });
  }

  function entryForVariant(variantId) {
    return renderedEntries.find(function (entry) {
      return entry.variantId === String(variantId);
    });
  }

  function updateQuantity(input) {
    var entry = entryForVariant(input.getAttribute('data-saved-quantity'));
    if (!entry) return;

    var quantity = parseInt(input.value, 10);
    if (!quantity || quantity < 1) quantity = 1;
    quantity = Math.min(quantity, entry.maxQuantity || 999);
    input.value = String(quantity);
    entry.quantity = quantity;

    var row = input.closest('[data-saved-row]');
    var printQuantity = row && row.querySelector('.saved-products__print-quantity');
    if (printQuantity) printQuantity.textContent = 'Antal: ' + quantity;

    if (!sharedMode && typeof saved.setQuantity === 'function') {
      saved.setQuantity(entry.variantId, quantity, { source: 'saved-page' });
    }
    renderPrintDocument(renderedEntries);
  }

  function shareUrl() {
    var shareable = renderedEntries.filter(function (entry) {
      return entry.handle && entry.variantId;
    }).map(function (entry) {
      return encodeURIComponent(entry.handle) + '~' + encodeURIComponent(entry.variantId) + '~' + entry.quantity;
    });
    var url = new URL(pageUrl, window.location.origin);
    url.searchParams.set('lista', shareable.join(','));
    return url.toString();
  }

  function copyShareUrl(url) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(url);
    }
    window.prompt('Kopiera länken till listan:', url);
    return Promise.resolve();
  }

  function addItemsToCart(items) {
    return fetch(joinRoot('cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      if (!response.ok) return response.json().catch(function () { return {}; }).then(function (payload) {
        throw new Error(payload.description || 'Produkterna kunde inte läggas i varukorgen.');
      });
      return response.json();
    }).then(function (payload) {
      if (window.themeCart && typeof window.themeCart.sync === 'function') {
        return Promise.resolve(window.themeCart.sync()).catch(function () { return null; }).then(function () {
          return payload;
        });
      }
      return payload;
    });
  }

  shareButton.addEventListener('click', function () {
    var url = shareUrl();
    var shareData = { title: page.getAttribute('data-share-title') || 'Prisunderlag', url: url };
    var action = navigator.share ? navigator.share(shareData) : copyShareUrl(url);

    Promise.resolve(action).then(function () {
      saved.publish('saved_list_shared', { item_count: renderedEntries.length });
      saved.announce('Listan har delats.');
      if (!navigator.share) {
        var oldText = shareLabel.textContent;
        shareLabel.textContent = 'Länk kopierad';
        shareButton.classList.add('is-complete');
        window.setTimeout(function () {
          shareLabel.textContent = oldText;
          shareButton.classList.remove('is-complete');
        }, 1800);
      }
    }).catch(function (shareError) {
      if (shareError && shareError.name === 'AbortError') return;
      copyShareUrl(url).then(function () {
        saved.announce('Länken till listan har kopierats.');
      });
    });
  });

  printButton.addEventListener('click', function () {
    saved.publish('saved_list_printed', { item_count: renderedEntries.length });
    updatePrintTimestamp();
    if (typeof window.print === 'function') window.print();
  });

  window.addEventListener('beforeprint', updatePrintTimestamp);

  importButton.addEventListener('click', function () {
    saved.addMany(renderedEntries, { source: 'shared-list' });
    importButton.disabled = true;
    importButton.textContent = 'Listan är sparad';
    saved.announce('Produkterna har lagts till bland dina sparade produkter.');
  });

  addAllButton.addEventListener('click', function () {
    var purchasable = renderedEntries.filter(function (entry) {
      return entry.available;
    });
    if (purchasable.length === 0) return;

    addAllButton.disabled = true;
    addAllLabel.textContent = 'Lägger till…';
    error.hidden = true;

    addItemsToCart(purchasable.map(function (entry) {
      return { id: Number(entry.variantId), quantity: entry.quantity };
    })).then(function () {
      addAllLabel.textContent = 'Alla tillagda';
      saved.publish('saved_list_added_to_cart', {
        item_count: purchasable.length,
        quantity: purchasable.reduce(function (sum, entry) { return sum + entry.quantity; }, 0)
      });
      saved.announce('Alla tillgängliga produkter lades i varukorgen.');
      window.setTimeout(function () {
        addAllButton.disabled = false;
        addAllLabel.textContent = 'Lägg alla i varukorgen';
      }, 1600);
    }).catch(function (cartError) {
      addAllButton.disabled = false;
      addAllLabel.textContent = 'Lägg alla i varukorgen';
      error.textContent = cartError.message || 'Produkterna kunde inte läggas i varukorgen.';
      error.hidden = false;
      saved.announce(error.textContent);
    });
  });

  page.addEventListener('change', function (event) {
    if (event.target.matches('[data-saved-quantity]')) updateQuantity(event.target);
  });

  page.addEventListener('click', function (event) {
    var quantityButton = event.target.closest('[data-qty-decrease], [data-qty-increase]');
    if (quantityButton && quantityButton.closest('[data-saved-products-page]')) {
      var quantityInput = quantityButton.closest('[data-qty-stepper]').querySelector('[data-saved-quantity]');
      /* cart.js äger temats gemensamma stegare och kör på document efter den
         här lyssnaren. Läs därför värdet i nästa macrotask, när +/- är klart. */
      window.setTimeout(function () { updateQuantity(quantityInput); }, 0);
      return;
    }

    var removeButton = event.target.closest('[data-saved-page-remove]');
    if (removeButton) {
      saved.remove(removeButton.dataset.savedPageRemove, { source: 'saved-page' });
      saved.announce('Produkten har tagits bort från sparade produkter.');
      return;
    }

    var cartButton = event.target.closest('[data-saved-cart]');
    if (!cartButton) return;
    var entry = entryForVariant(cartButton.dataset.savedCart);
    if (!entry || !entry.available) return;

    setCartButtonState(cartButton, 'loading', entry);
    error.hidden = true;

    addItemsToCart([{ id: Number(entry.variantId), quantity: entry.quantity }]).then(function () {
      setCartButtonState(cartButton, 'added', entry);
      saved.publish('saved_product_added_to_cart', {
        variant_id: entry.variantId,
        quantity: entry.quantity
      });
      saved.announce('Produkten lades i varukorgen.');
      window.setTimeout(function () {
        setCartButtonState(cartButton, 'idle', entry);
      }, 1600);
    }).catch(function (cartError) {
      setCartButtonState(cartButton, 'idle', entry);
      error.textContent = cartError.message || 'Produkten kunde inte läggas i varukorgen.';
      error.hidden = false;
      saved.announce(error.textContent);
    });
  });

  document.addEventListener('saved-products:updated', function (event) {
    if (!sharedMode && (!event.detail || event.detail.action !== 'quantity')) render();
  });

  render();
})();
